/* Mobile nav drawer sliding panels */
(function() {
    function initMobileDrawerNav(drawer) {
        if (!drawer || drawer.dataset.mobileDrawerBound === 'true') {
            return;
        }

        var nav = drawer.querySelector('[data-mobile-nav-drawer]');
        if (!nav) {
            return;
        }

        var rootPanel = nav.querySelector('[data-panel-id="main"]');
        if (!rootPanel) {
            return;
        }

        drawer.dataset.mobileDrawerBound = 'true';

        function setActivePanel(panelId) {
            var panels = nav.querySelectorAll('[data-panel-id]');
            var isRoot = panelId === 'main';

            panels.forEach(function(panel) {
                var active = panel.getAttribute('data-panel-id') === panelId;
                panel.classList.toggle('is-active', active);
                panel.setAttribute('aria-hidden', active ? 'false' : 'true');
            });

            nav.classList.toggle('is-submenu-open', !isRoot);
            drawer.classList.toggle('is-submenu-open', !isRoot);

            var triggers = nav.querySelectorAll('.mobile-nav-drawer__trigger[aria-controls]');
            triggers.forEach(function(trigger) {
                trigger.setAttribute('aria-expanded', trigger.getAttribute('aria-controls') === panelId ? 'true' : 'false');
            });
        }

        nav.addEventListener('click', function(evt) {
            var openBtn = evt.target.closest('.mobile-nav-drawer__trigger[aria-controls]');
            if (openBtn && nav.contains(openBtn)) {
                evt.preventDefault();
                setActivePanel(openBtn.getAttribute('aria-controls'));
                return;
            }

            var backBtn = evt.target.closest('[data-mobile-nav-back]');
            if (backBtn && nav.contains(backBtn)) {
                evt.preventDefault();
                setActivePanel('main');
            }
        });

        var observer = new MutationObserver(function() {
            if (!drawer.classList.contains('drawer--is-open')) {
                setActivePanel('main');
            }
        });

        observer.observe(drawer, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function initAllMobileDrawerNav() {
        var drawer = document.getElementById('NavDrawer');
        if (drawer) {
            initMobileDrawerNav(drawer);
        }
    }

    document.addEventListener('DOMContentLoaded', initAllMobileDrawerNav);
    document.addEventListener('shopify:section:load', initAllMobileDrawerNav);
})();


/* Custom Video Player - Simple accessible Play/Pause button */
class CustomVideo extends HTMLElement {
  connectedCallback() {
    this.playLabel = this.getAttribute('label-play') || 'Play';
    this.pauseLabel = this.getAttribute('label-pause') || 'Pause';
    this.video = this.querySelector('video');
    this.button = this.querySelector('.custom-video__button');

    if (!this.video || !this.button) return;

    this.button.setAttribute('aria-label', this.playLabel);
    this.button.addEventListener('click', () => this.toggle());
    this.video.addEventListener('play', () => this.update(true));
    this.video.addEventListener('pause', () => this.update(false));
  }

  toggle() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  update(isPlaying) {
    this.button.classList.toggle('is-playing', isPlaying);
    this.button.setAttribute('aria-label', isPlaying ? this.pauseLabel : this.playLabel);
  }
}

customElements.define('custom-video', CustomVideo);


/* Custom Modal Drawers */
document.addEventListener('click', (event) => {
  const openModalDrawer = event.target.closest('.js-open-modal-drawer');
  const closeModalDrawer = event.target.closest('.js-close-modal-drawer');

  if (openModalDrawer) {
    const target = openModalDrawer.dataset.target;
    const drawer = document.querySelector(`.js-modal-drawer[data-drawer="${target}"]`);
    drawer.showModal();
  }

  if (closeModalDrawer) {
    const drawer = closeModalDrawer.closest('.js-modal-drawer');
    drawer.close();
  }
});
// Close when clicking backdrop */
document.querySelectorAll('.js-modal-drawer').forEach((drawer) => {
  drawer.addEventListener('click', (event) => {
    const rect = drawer.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!inside) {
      drawer.close();
    }
  });
});

/* Product Card Add To Cart */
/* Made to work on recommended products section and complimentary products snippet */
const productFormSelector = 'form[id^="form_add-"]';
const productCardButtonSelector = '.product-card__add-to-cart';
const complementaryRecommendationsSelector = 'product-recommendations[data-intent="complementary"]';

function initAjaxProductCardForms(container = document) {
  if (
    !window.theme
    || !theme.AjaxProduct
    || theme.settings?.cartType !== 'drawer'
    || !container
    || typeof container.querySelectorAll !== 'function'
  ) {
    return;
  }

  container
    .querySelectorAll(productFormSelector)
    .forEach((form) => {
      if (!(form instanceof HTMLFormElement) || !form.querySelector(productCardButtonSelector)) {
        return;
      }

      if (form.dataset.ajaxBound === 'true') {
        return;
      }

      form.dataset.ajaxBound = 'true';
      new theme.AjaxProduct(form, productCardButtonSelector);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initAjaxProductCardForms();
});

document.addEventListener('shopify:section:load', (event) => {
  initAjaxProductCardForms(event.target);
});

document.addEventListener('recommendations:loaded', (event) => {
  initAjaxProductCardForms(event.detail?.section || document);
});

async function submitProductCardAddToCart(data, addToCartBtn) {
  if (addToCartBtn) {
    addToCartBtn.classList.add('btn--loading');
  }

  try {
    const response = await fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    const product = await response.json();

    if (!response.ok || product.status === 422) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: product.description || 'Unable to add this item to your cart.',
        },
      }));
      return;
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product,
        addToCartBtn,
      },
    }));
  } catch (error) {
    console.error('Product card add-to-cart failed', error);
  } finally {
    if (addToCartBtn) {
      addToCartBtn.classList.remove('btn--loading');
    }
  }
}

async function submitProductCardViaAjax(form) {
  const addToCartBtn = form.querySelector(productCardButtonSelector);
  const data = new URLSearchParams(new FormData(form)).toString();
  await submitProductCardAddToCart(data, addToCartBtn);
}

document.addEventListener('submit', async (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  if (!form.matches(productFormSelector) || !form.closest(complementaryRecommendationsSelector)) {
    return;
  }

  if (!window.theme || theme.settings?.cartType !== 'drawer') {
    return;
  }

  // If AjaxProduct is already bound, let the theme handler run.
  if (form.dataset.ajaxBound === 'true') {
    return;
  }

  event.preventDefault();
  await submitProductCardViaAjax(form);
});

/* Standalone (form-less) add to cart button used where a nested <form> would be invalid, */
/* e.g. cart drawer mobile recommendations rendered inside the main CartDrawerForm. */
const standaloneAddToCartSelector = '[data-add-to-cart-standalone]';

document.addEventListener('click', async (event) => {
  const button = event.target.closest(standaloneAddToCartSelector);

  if (!button) {
    return;
  }

  event.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) {
    return;
  }

  const quantity = button.dataset.quantity || 1;
  const data = new URLSearchParams({ id: variantId, quantity }).toString();
  await submitProductCardAddToCart(data, button);
});
